import {Controller} from "@hotwired/stimulus"

// Record shipment modal: a shipment needs exactly ONE vendor shipping line
// (Shipment#validate_shipping_line_item), and quantity is never a choice for them --
// they are a single unit. So the control is a radio group, not a set of checkboxes and
// not a set of number inputs: picking one drops whatever was picked before.
//
// Each candidate is a "group" -- either a table row for a vendor shipping line already
// on the order, or the panel offering the next unused number from the pool. Inside a
// group, plain data attributes mark the hidden field and the two buttons, so adding a
// group needs no changes here.
//
// The hidden field is what the server reads, and its off value is what removes the line:
//   - a nested quantity of 0 is dropped by Shipment#remove_zero_quantity_line_items
//   - the add_vendor_shipping flag at 0 stops the controller creating a new line
//
// Initial selection comes from the server, read back off the fields rather than passed
// in, so a re-rendered modal keeps whatever was submitted.
export default class extends Controller {
    static targets = ["group"]

    connect() {
        this.selectedIndex = this.groupTargets.findIndex((group) => {
            const field = this.fieldFor(group)
            return field && Number(field.value) > 0
        })
        this.render()
    }

    select(event) {
        this.selectedIndex = this.indexOf(event.currentTarget)
        this.render()
    }

    deselect(event) {
        if (this.selectedIndex === this.indexOf(event.currentTarget)) this.selectedIndex = -1
        this.render()
    }

    render() {
        this.groupTargets.forEach((group, index) => {
            const selected = index === this.selectedIndex
            const field = this.fieldFor(group)

            if (field) {
                field.value = selected ? (field.dataset.onValue || "1") : (field.dataset.offValue || "0")
            }

            this.show(group.querySelector("[data-vendor-shipping-remove]"), selected)
            this.show(group.querySelector("[data-vendor-shipping-add]"), !selected)
            this.show(group.querySelector("[data-vendor-shipping-included]"), selected)
            this.show(group.querySelector("[data-vendor-shipping-excluded]"), !selected)
        })
    }

    fieldFor(group) {
        return group.querySelector("[data-vendor-shipping-field]")
    }

    indexOf(element) {
        return this.groupTargets.indexOf(element.closest('[data-vendor-shipping-target~="group"]'))
    }

    // Inline display rather than a `hidden` attribute or an `ice:hidden` class: these
    // elements carry their own display utility (inline-flex), and a class or the UA
    // [hidden] rule does not reliably outrank it.
    show(element, visible) {
        if (!element) return
        element.style.display = visible ? "" : "none"
    }
}
